import { Phone, TrendingUp, MessageSquare } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const UseCases = () => {
  const { t } = useTranslation();
  
  const cases = [
    {
      icon: Phone,
      title: t('useCases.inbound_title'),
      description: t('useCases.inbound_desc'),
      benefit: t('useCases.inbound_benefit'),
    },
    {
      icon: TrendingUp,
      title: t('useCases.outbound_title'),
      description: t('useCases.outbound_desc'),
      benefit: t('useCases.outbound_benefit'),
    },
    {
      icon: MessageSquare,
      title: t('useCases.support_title'),
      description: t('useCases.support_desc'),
      benefit: t('useCases.support_benefit'),
    },
  ];

  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">{t('useCases.title')}</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('useCases.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {cases.map((useCase, index) => (
            <Card
              key={index}
              className="p-8 hover:shadow-xl transition-all duration-300 bg-card border-border group"
            >
              <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <useCase.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-card-foreground">{useCase.title}</h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">{useCase.description}</p>
              <div className="inline-block px-4 py-2 rounded-full bg-accent/10 text-accent font-semibold text-sm">
                {useCase.benefit}
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/solutions">
            <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
              {t('useCases.cta')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
